import { getAbTestV2 } from '../utils/abTest/clientAbTestV2';

export const EMAIL_ONLY_CHECKOUT_TEST_NAME = 'emailOnlyCheckout';

const FASTER_CHECKOUT_TEST_NAME = 'faster-checkout-q3-2023';
const FASTER_CHECKOUT_VARIANT_NAME = 'fcq3-2023-variant';

export const isEmailOnlyCheckoutVariant = (): boolean =>
    getAbTestV2(EMAIL_ONLY_CHECKOUT_TEST_NAME)?.variant === 'variant' &&
    getAbTestV2(FASTER_CHECKOUT_TEST_NAME)?.variant === FASTER_CHECKOUT_VARIANT_NAME;
